import { types, actions } from './requests'
export const CREATEMATERIAL_TYPES = {
    ...types('CREATEMATERIAL'),
}
export const CREATEMATERIAL_ACTIONS = {
    ...actions('CREATEMATERIAL'),
}